<template>
  <div :class="['app_wrap']">
    <!--    <div style="height: 200px;"></div>-->
    <!--    <count/>-->
    <router-view />
  </div>
</template>

<script>
var fromurl=document.referrer;
if (fromurl.indexOf("hm.ta108.com") > -1)
{

}else
{
	var sUserAgent = navigator.userAgent.toLowerCase();
	if (
	  /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
	    sUserAgent
	  )
	) {
	  //跳转移动端页面
    //20240624注释掉自动跳转到手机版本，电脑手机版本切换功能去掉
	  //window.location.href = "https://hm.ta108.com/login";
	}
}
export default {
  name: "p_app",
  data() {
    return {
      // date-picker 配置
      time: new Date(),
      range: [new Date(), new Date()],
      emptyTime: "",
      emptyRange: [],
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        cancelTip: "cancel",
        submitTip: "confirm"
      }
    };
  }
};
</script>

<style lang="stylus">
/* **
 * load theme
 */
@import './styles/theme-1.styl';
@import './styles/theme-2.styl';
@import './styles/theme-3.styl';

body .c_time .countdown {
  white-space: nowrap;
}

body .countdown > .count-wrap {
  display: inline-block;
  float: none;
  vertical-align: top;
}

/* **
 * 清除浮动
 */
.clear_fix {
  &:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: ' ';
    clear: both;
    height: 0;
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}
/*登录皮肤1*/
.app_wrap {
  min-height: 100%;
  position: relative;
  background: linear-gradient(0deg, #409eff, transparent);
  background-size: cover;
}
/*登录皮肤2*/
/*.app_wrap {
  min-height: 100%;
  position: relative;
  background: var(--app-wrap) no-repeat center top;
}*/

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/app.vue